import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetPatientProfileFooterAppointmentDocument,
  PatientProfileFooterAppointmentFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';

export const useFetchAppointment = (
  appointmentId: string,
): PatientProfileFooterAppointmentFragment | undefined => {
  const [event, clear] = useSubscriptions('Appointment', ['updated']);

  const [getAppointment, { data }] = useLazyQuery(GetPatientProfileFooterAppointmentDocument, {
    fetchPolicy: 'network-only',
  });

  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (!data || !event) return;

    clear();
  }, [clear, data, event]);

  useEffect(() => {
    if (appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getAppointment]);

  useEffect(() => {
    if (event?.actionName === 'updated' && event.typeId === appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, event?.actionName, event?.typeId, getAppointment]);

  return appointment;
};
